import { useWeb3React } from '@web3-react/core'
import React, { useEffect, useState } from 'react'

interface IProps {
  children: React.ReactNode
}

export function RefreshOnAccountChange(props: IProps) {
  const userContext = useWeb3React()

  const [currentAccount, setCurrentAccount] = useState(null)

  useEffect(() => {
    if (userContext && currentAccount && currentAccount !== userContext.account) {
      window.location.reload()
    } else {
      setCurrentAccount(userContext.account)
    }
  }, [currentAccount, userContext, userContext.account])

  return <div className="refresh-on-account-change">{props.children}</div>
}
